module.exports = __webpack_public_path__ + "img/8.c6a805e3.png";